<template>
  <the-section class="cart" :title="$t('ec-line003.content.tilte')">
    <el-row>
      <el-col :span="24">
        <slot v-bind:items="items"></slot>
      </el-col>
    </el-row>
    <el-row class="border-b border-solid border-gray-950 border-opacity-70 pb-4">
      <el-col
        v-if="summary && summary.status && Number(summary.delivery_fee) === 0"
        :span="24"
        class="p-4 bg-gray rounded-lg text-base"
        v-html="$t('ec-line003.content.freeHint')"
      ></el-col>
      <el-col
        v-else-if="summary && summary.status && subtotalExcludeDiscount < freeAmount"
        :span="24"
        class="p-4 bg-gray rounded-lg text-base"
        v-html="$t('ec-line003.content.hint', { price: $n(freeAmount - subtotalExcludeDiscount, 'currency', 'ja-JP') })"
      ></el-col>
      <el-col
        v-else-if="summary && summary.status && subtotalExcludeDiscount >= freeAmount"
        :span="24"
        class="p-4 bg-gray rounded-lg text-base"
        v-html="$t('ec-line003.content.freeHint')"
      ></el-col>
    </el-row>
    <el-row type="flex" class="mt-8 mb-2 flex-wrap items-end text-base">
      <div v-if="summary && summary.status && !lupSumValidFlag" class="ml-auto">
        <el-col :span="18" :offset="6" class="mb-2">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col class="flex items-center">
              <span>{{ $t('common.label.subtotal') }}</span>
              <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
              <el-popover
                class="ml-2"
                :tabindex="2"
                placement="top"
                title=""
                width="200"
                trigger="hover"
                :content="$t('common.cart.subtotalExplanation')"
              >
                <span slot="reference">
                  <img :src="require('@/assets/images/help-round-icon.svg')" alt="" />
                </span>
              </el-popover>
            </el-col>
            <el-col class="text-right">{{ $n(summary.subtotal, 'currency', 'ja-JP') }}</el-col>
          </el-row>
        </el-col>
        <el-col v-if="hasDiscountAmount" :span="18" :offset="6" class="">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col class="text-xs flex items-center">
              {{ $t('common.label.priceDiscount') }}
              <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
            </el-col>
            <el-col class="text-right tex-xs text-red"
              >({{ $n(summary.discount_amount_total, 'currency', 'ja-JP') }})</el-col
            >
          </el-row>
        </el-col>
        <el-col v-if="user && user.rank_name && hasDiscountAmount && user.rank_use_flag" :span="18" :offset="6">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col class="text-xs text-left text-red">{{
              $t('common.messages.rankDiscount', { rankMember: user.rank_name })
            }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="18" :offset="6" class="">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col class="flex items-center">
              {{ $t('common.label.deliveryFee') }}
              <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
            </el-col>
            <el-col class="text-right">{{ $n(summary.delivery_fee, 'currency', 'ja-JP') }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="18" :offset="6" class="font-bold mb-2">
          <br />
          <el-row type="flex" justify="space-between" align="middle">
            <el-col class="flex items-center">
              {{ $t('cartList.item.total') }}
              <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
            </el-col>
            <el-col class="text-right text-2xl">{{ $n(summary.payment_total, 'currency', 'ja-JP') }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="18" :offset="6" class="font-bold mb-2">
          <el-row type="flex" justify="space-between" align="middle">
            <br />
            <el-col class="text-xs text-left">{{ $t('cartList.item.consumptionTax') }}</el-col>
            <el-col class="text-right text-xs">({{ $n(summary.tax_total, 'currency', 'ja-JP') }})</el-col>
          </el-row>
        </el-col>
      </div>
      <div v-else-if="lupSumValidFlag" class="text-red text-lg">
        <p>{{ $t('ec-line003.message.lumpSumMessage1') }}</p>
        <p>{{ $t('ec-line003.message.lumpSumMessage2') }}</p>
        <p>{{ $t('ec-line003.message.lumpSumMessage3') }}</p>
      </div>
      <div v-else-if="summary && !summary.status" class="text-red text-lg">
        <p>{{ $t('ec-line003.message.otherErrorMessage') }}</p>
      </div>
    </el-row>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
export default {
  components: { TheSection },
  props: {
    items: { type: Array, default: () => [] },
    freeAmount: { type: Number, default: () => 0 },
    summary: { type: Object, default: () => {} },
    lupSumValidFlag: Boolean,
  },
  computed: {
    hasDiscountAmount() {
      return this.summary.discount_amount_total && Number(this.summary.discount_amount_total) < 0
    },
    subtotalExcludeDiscount() {
      return this.summary.subtotal - Number(this.summary.discount_amount_total)
    },
  },
}
</script>

<style></style>
